import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { retryTimerSave, syncTaskTimer } from '../../../shared/api/taskTimer';
import '../lib/index.css';

// One notification for the whole app, including screens with no task rows.
export function TimerError() {
    const dispatch = useDispatch();
    const timer = useSelector((state: any) => state.stopWatchesData);
    if (!timer.error) return null;
    return <div role="alert" className="timer-error">
        <span>{timer.error}</span>
        <button type="button" disabled={timer.busy} onClick={() => {
            dispatch<any>(timer.pendingSave ? retryTimerSave() : syncTaskTimer()).catch(() => {});
        }}>{timer.pendingSave ? 'Повторить сохранение' : 'Обновить состояние'}</button>
    </div>;
}
